module.exports = __webpack_public_path__ + "static/media/setting.30b448da.svg";